<template>
  <div>
    <el-dialog
      title="系统提示"
      :visible.sync="dialogBatchVisible"
      :before-close="handleClose"
    >
      <div :id="this.dialogType == 'audit' ? 'audit-detail' : 'task-detail'">
        <el-row v-show="dialogType == 'audit'" class="task-top">
          <el-col :span="3" class="total-wrapper">
            <div class="total-left">总笔数：</div>
            <div class="total-right">
              {{ this.totalNumber }}
              <span class="total-right bi">笔</span>
            </div>
          </el-col>
          <el-col :span="5" class="total-wrapper">
            <div class="total-left">总金额：</div>
            <div class="total-right">
              {{ this.totalPrice }}
              <span class="total-right bi">元</span>
            </div>
          </el-col>
          <el-col class="total-wrapper">
              <div class="total-left">预抵扣税费合计：</div>
              <div class="total-right">
                {{ this.now_tax_money }}
                <span class="total-right bi">元</span>
              </div>
            </el-col>
          <el-col class="table-right">
            <el-select v-model="value" @change="selectData" class="select-box">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              :loading="downloadLoading"
              type="primary"
              class="export-table"
              size="medium"
              icon="el-icon-document"
              @click="sendHandleDownload"
            >
              导出
            </el-button>
          </el-col>
        </el-row>
        <el-row id="detail-table" v-show="dialogType == 'detail'">
          <ApeTable
            ref="apeTable"
            :data="statusList"
            :columns="columnsStatus"
            :loading="loadingStaus"
            highlight-current-row
          >
          </ApeTable>
        </el-row>

        <el-row v-show="dialogType == 'detail'" class="task-top">
          <el-col :span="3" class="total-wrapper">
            <div class="total-left">总笔数：</div>
            <div class="total-right">
              {{ this.totalNumber }}
              <span class="total-right bi">笔</span>
            </div>
          </el-col>
          <el-col :span="5" class="total-wrapper">
            <div class="total-left">总金额：</div>
            <div class="total-right">
              {{ this.totalPrice }}
              <span class="total-right bi">元</span>
            </div>
          </el-col>
          <el-col class="total-wrapper">
              <div class="total-left">预抵扣税费合计：</div>
              <div class="total-right">
                {{ this.now_tax_money }}
                <span class="total-right bi">元</span>
              </div>
            </el-col>
          <el-col class="table-right">
            <el-form style="height: 40px; line-height: 40px" :inline="true">
              <el-form-item>
                <el-select
                  v-model="stateValue"
                  @change="selectState"
                  class="select-state-box"
                >
                  <el-option
                    v-for="item in stateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-select v-model="value" @change="selectData" class="select-box">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              :loading="downloadLoading"
              type="primary"
              class="export-table"
              size="medium"
              icon="el-icon-document"
              @click="handleDownload"
            >
              导出
            </el-button>
          </el-col>
        </el-row>

        <el-row id="audit-table" v-show="this.dialogType == 'detail'">
          <ApeTable
            ref="detailApeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            @switchPaging="switchPaging"
            highlight-current-row
          >
            <el-table-column prop="alias_code" label="银行回馈码">
              <template slot-scope="scope">
                <el-tag
                  :type="
                    scope.row.alias_code === '-'
                      ? 'info'
                      : scope.row.alias_code === '0000'
                      ? 'success'
                      : 'danger'
                  "
                  >{{ scope.row.alias_code }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="alias_msg" label="银行回馈消息">
              <template slot-scope="scope">
                <div
                  :style="
                    scope.row.alias_msg === '未处理'
                      ? 'color: #909399'
                      : scope.row.alias_msg === '已发放'
                      ? 'color: #67c23a'
                      : 'color: #f56c6c'
                  "
                >
                  {{ scope.row.alias_msg }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="alias_msg" label="电子回单">
              <template slot-scope="scope">
                <el-button
                  size="medium"
                  @click="mxViewReceipt(scope.row.outer_trade_no,baseInfo.yl_bank,'',scope.row.ele_receipt_url)"
                  type="success"
                  plain
                  >查看电子回单</el-button
                >
              </template>
            </el-table-column>
          </ApeTable>
        </el-row>
        <el-row id="audit-table" v-show="dialogType == 'audit'">
          <ApeTable
            ref="auditApeTable"
            :data="dataList"
            :columns="columnsSend"
            :loading="loadingStaus"
            :pagingData="pagingData"
            @switchPaging="switchPaging"
            highlight-current-row
          >
          </ApeTable>
        </el-row>
        <el-row class="center" v-show="this.dialogType == 'audit'">
          <el-col class="text-center" :span="10">
            <el-button type="" size="medium" @click="handleSubmit('3')"
              >审核不通过</el-button
            >
            <el-button type="danger" size="medium" @click="handleSubmit('2')"
              >请仔细检查数据，确认无误后开始下发</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <verification
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleSuccess($event)"
      :dialogVisible="dialogVisible"
      :is_verify="false"
    />
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import ApeDrawer from "@/components/ApeDrawer";
import ApeUploader from "@/components/ApeUploader";
import ModalDialog from "@/components/ModalDialog";
import Verification from "@/components/Verification";
import { mapGetters } from "vuex";

export default {
  components: {
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    Verification,
  },
  props: {
    dialogBatchVisible: {
      type: Boolean,
      default: false,
    },
    batchId: {
      type: String,
      default: "",
    },
    dialogType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      now_tax_money:0,
      //发放状态
      stateOptions: [
        {
          value: "",
          label: "全部发放状态",
        },
        {
          value: "00",
          label: "未处理",
        },
        {
          value: "02",
          label: "发放失败",
        },
        {
          value: "11",
          label: "已发放",
        },
      ],
      stateValue: "全部发放状态",
      isShow: false,
      dialogVisible: false,
      downloadLoading: false,
      //dialog状态
      dialogStatus: false,
      // element的cascader的props值
      cascaderProps: {
        label: "display_name",
        value: "id",
      },
      type: "",
      tableData: [],
      tableHeader: [],
      searchCategory: [],
      taskList: [],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      columnsStatus: [
        {
          title: "结算笔数",
          header_align: "center",
          align: "center",
          value: "total_num",
        },
        {
          title: "结算金额",
          header_align: "center",
          align: "center",
          value: "total_amount",
        },
        {
          title: "成功笔数",
          header_align: "center",
          align: "center",
          value: "succeed_num",
        },
        {
          title: "成功金额",
          header_align: "center",
          align: "center",
          value: "succeed_money",
        },
        {
          title: "失败笔数",
          header_align: "center",
          align: "center",
          value: "failed_num",
        },
        {
          title: "失败金额",
          header_align: "center",
          align: "center",
          value: "failed_money",
        },
      ],
      statusList: [
        {
          number: "10",
          price: "100.00",
          success_num: "23",
          succeed_money: "20.00",
          fail_num: "2",
          failed_money: "23.00",
        },
      ],
      status: "", // 审核状态
      //导出格式
      options: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      value: "xlsx",
      //导出表格类型
      bookType: "xlsx",
      columns: [
        {
          title: "姓名",
          header_align: "center",
          align: "center",
          value: "bank_account_name",
        },
        {
          title: "收款账号",
          header_align: "center",
          align: "center",
          value: "bank_account_no",
        },
        {
          title: "下发通道",
          header_align: "center",
          align: "center",
          value: "alias_send_type",
        },
        // {
        //   title: "证件类型",
        //   header_align: 'center',
        //   align: 'center',
        //   value: "alias_id_type",
        // },
        // {
        //   title: "证件号码",
        //   header_align: 'center',
        //   align: 'center',
        //   value: "id_number",
        // },
        // {
        //   title: "手机号码",
        //   header_align: 'center',
        //   align: 'center',
        //   value: "mobile",
        // },
        {
          title: "附属信息",
          width: 300,
          value: [
            { label: "证件类型：", value: "alias_id_type" },
            { label: "证件号码：", value: "id_number" },
            { label: "手机号码：", value: "mobile" },
            { label: "编码：", value: "code" },
          ],
          header_align: "center",
          /*   align: 'center', */
        },
        {
          title: "结算金额",
          value: "money",
        },
        {
          title: "实收金额",
          value: "after_money",
        },
        {
          title: "个税",
          value: "now_tax_money",
        },
		{
		title: "预扣增值税和附加税",
		value: "added_tax_money",
		header_align: "center",
		align: "center",
		width: 180,
		},
        /* {
          title: "银行回馈码",
          header_align: 'center',
          align: 'center',
          value: "alias_code",
          color: "",
          fontWeight: 'bold'
        },
        {
          title: "银行回馈消息",
          header_align: 'center',
          align: 'center',
          value: "alias_msg",
          color: "",
          fontWeight: 'bold'
        }, */
      ],
      columnsSend: [
        {
          title: "姓名",
          header_align: "center",
          align: "center",
          value: "bank_account_name",
        },
        {
          title: "收款账号",
          header_align: "center",
          align: "center",
          value: "bank_account_no",
        },
        {
          title: "下发通道",
          header_align: "center",
          align: "center",
          value: "send_type",
        },
        {
          title: "证件类型",
          header_align: "center",
          align: "center",
          value: "id_type",
        },
        {
          title: "证件号码",
          header_align: "center",
          align: "center",
          value: "id_number",
        },
        {
          title: "手机号码",
          header_align: "center",
          align: "center",
          value: "mobile",
        },
        {
          title: "下发金额",
          value: "money",
          header_align: "center",
          align: "center",
        },
        {
          title: "开户行名称",
          header_align: "center",
          align: "center",
          value: "bank_branch",
        },
        {
          title: "编码",
          header_align: "center",
          align: "center",
          value: "code",
        },
        {
          title: "上传时间",
          header_align: "center",
          align: "center",
          value: "created_at",
        },
      ],
      // 表格列表数据
      baseInfo: {},
      dataList: [],
      //导出表格数据
      exportList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, prev, pager, next",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      pagingInfo: {},
      totalNumber: "", //总笔数
      totalPrice: "", //总金额
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
  },
  watch: {
    batchId(val, oldval) {
      if (oldval != val) {
        console.log(oldval, val);
      }
    },
    dialogBatchVisible(val) {
      if (val == true) {
        if (this.batchId) {
          this.init();
        }
      }
    },
  },
  methods: {
    //选择发放状态
    selectState(e) {
      this.searchCondition.send_status = e;
      if (!this.searchCondition.send_status) {
        delete this.searchCondition.send_status;
      }
      this.init("search");
    },
    //关闭小X
    handleClose() {
      this.dataList = [];
      this.searchCondition.send_status = "";
      this.stateValue = "全部发放状态";
      if (this.dialogType == "audit") {
        this.$refs["auditApeTable"].handleCurrentChange(1);
      } else {
        this.$refs["detailApeTable"].handleCurrentChange(1);
      }
      this.$emit("dialogChanged", this.dialogType);
    },
    async handleSuccess(e) {
      const res = await this.$api.auditAdminTask({
        batch_id: this.batchId,
        status: this.status, // 2审核通过，3审核不通过
        ...e
      });
      if (res) {
        // 关闭弹窗
        let msg = this.status == 2 ? "提交成功，请等待系统下发!" : "提交成功！";
        this.$message.success(msg);
        this.dialogChanged(false);
        this.$emit("onSuccess");
      }
    },
    //返回上一页
    goBack() {
      this.$router.push(this.$route.matched[1].path);
    },
    // 控制弹窗
    dialogChanged(state) {
      this.dialogVisible = state;
    },
    // 表单提交
    async handleSubmit(status) {
      this.status = status;
      if (this.dataList.length <= 0) {
        return this.$message.error("提交失败，数据不能为空!");
      }

      // 验证手机号(调试完代码恢复此处)
      this.dialogChanged(true);
    },
    // 搜索
    searchButton() {
      this.init();
    },
    //选择导出表格格式
    selectData(e) {
      this.bookType = e;
    },

    //导出表格数据
    async sendHandleDownload() {
      this.downloadLoading = true;
      import("@/excel/Export2Excel").then((excel) => {
        const tHeader = [
          "姓名",
          "收款账号",
          "下发通道",
          "证件类型",
          "证件号码",
          "手机号码",
          "下发金额",
		"个税",
		"预扣增值税和附加税",
          "开户行名称",
          "编码",
          "上传时间",
        ];
        const data = this.sendFormatJson(this.exportList);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `审核端审批任务${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    sendFormatJson(jsonData) {
      return jsonData.map((v) => {
        let {
          bank_account_name,
          bank_account_no,
          send_type,
          id_type,
          id_number,
          mobile,
          money,
		now_tax_money,
		added_tax_money,
          bank_branch,
          code,
          created_at,
        } = v;
        return [
          bank_account_name,
          bank_account_no,
          send_type,
          id_type,
          id_number,
          mobile,
          money,
		now_tax_money,
		added_tax_money,
          bank_branch,
          code,
          created_at,
        ];
      });
    },

    //导出表格数据
    async handleDownload() {
      this.downloadLoading = true;
      import("@/excel/Export2Excel").then((excel) => {
        const tHeader = [
          "姓名",
          "收款账号",
          "下发通道",
          "证件类型",
          "证件号码",
          "手机号码",
          "编码",
          "下发金额",
          "银行回馈码",
          "银行回馈消息",
        ];
        const data = this.formatJson(this.exportList);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `审核端发放明细${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let {
          bank_account_name,
          bank_account_no,
          alias_send_type,
          alias_id_type,
          id_number,
          mobile,
          code,
          money,
          alias_code,
          alias_msg,
        } = v;
        return [
          bank_account_name,
          bank_account_no,
          alias_send_type,
          alias_id_type,
          id_number,
          mobile,
          code,
          money,
          alias_code,
          alias_msg,
        ];
      });
    },
    //导入调转
    inportExcel() {
      this.$router.push({ path: "task/inport" });
    },
    // 初始化列表
    async init(type) {
      if (this.batchId) {
        var _this = this;
        let args = {
          id: this.batchId,
        };
        let searchCondition = this.handleSearchCondition();
        Object.assign(searchCondition, args);
        let { base, detail } = await this.$api.getAdminTaskInfo(
          searchCondition
        );
        // let {base, detail}= await this.$api.getAdminTaskInfo(this.batchId)
        this.baseInfo = base;
        this.dataList = detail;
        this.totalNumber = this.dataList.length;
        this.totalPrice = detail.reduce(function (total, currentValue) {
          return _this.$utils.sumTotal(total, currentValue.money);
        }, 0);
        this.now_tax_money = base.now_tax_money;

        this.exportList = detail;
        this.statusList = [base];
        if (this.dialogType == "audit") {
          this.pagingInfo = this.$refs["auditApeTable"].getPagingInfo(type);
        } else {
          this.pagingInfo = this.$refs["detailApeTable"].getPagingInfo(type);
        }
        this.pagingData.total = this.dataList.length;
        this.dataList = this.dataList.slice(
          this.pagingInfo.current_page * 10 - 10,
          this.pagingInfo.current_page * 10
        );
        this.pagingInfo.current_page = 1;
      }
      this.loadingStaus = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.send_status) {
        condition.send_status = this.searchCondition.send_status;
      }
      return condition;
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
  },
  created() {
    this.type = this.mxGetQuery("type");
  },
};
</script>

<style lang="stylus" scoped>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.title {
  font-size: 32px;
}

.desc {
  margin-bottom: 30px;
}

.center {
  display: flex;
  justify-content: center;
}

.text-center {
  text-align: center;
}

/deep/.el-dialog {
  width: 85%;
}

#audit-detail, #task-detail {
  padding: 0;
}

.detail-search {
  margin-left: 30px;
}

.total-wrapper {
  display: flex;
  flex-direction: row;
  padding: 0 10px;
  margin-top: 10px;
}

.total-left {
  color: #606266;
  font-size: 16px;
  text-align: left;
}

.total-right {
  color: red;
  font-size: 15px;
}

.bi {
  color: #606266;
}

.audit-top {
  height: 50px;
  padding-top: 10px;
}

.task-top {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

#audit-table {
  margin-top: -10px;
}

.table-right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.select-box {
  margin-right: 20px;
  width: 100px;
}

.select-state-box {
  width: 130px;
}
</style>
